import React, { useState } from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Collapse } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

interface Props {
    children: React.ReactNode;
    title: string;
    icon: React.ReactNode;
}

// NoteItemCollapse aligned with platform-v2, adapted to Material-UI v4
const NoteItemCollapse: React.FC<Props> = ({ children, title, icon }) => {
    const [open, setOpen] = useState<boolean>(false);

    const handleClick = () => setOpen((prev) => !prev);

    return (
        <List style={{ width: '100%', padding: 0 }}>
            <ListItem button onClick={handleClick}>
                <ListItemIcon style={{ minWidth: 40 }}>{icon}</ListItemIcon>
                <ListItemText primary={title} />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={open} timeout='auto' unmountOnExit>
                {children}
            </Collapse>
        </List>
    );
};

export default NoteItemCollapse;
